<template>
  <v-container>
    <v-expansion-panel popout light v-if="route !== 'Dashboard' && route !== 'Availability'" class="futuristic-expansion">
      <v-expansion-panel-content>
        <template slot="header">
          <h4 class="earth-color">GLOBAL SEARCH</h4>
        </template>
        <template slot="actions">
          <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs v-if="route !== 'Dashboard' && route !== 'Availability'"></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel popout light v-if="route === 'PartnerBookings'" class="futuristic-expansion">
      <v-expansion-panel-content>
        <template slot="header">
          <h4 class="earth-color">SEARCH PARAMETERS</h4>
        </template>
        <v-card flat class="futuristic-card">
          <v-layout row wrap>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Status"
                  v-model="booking_status_filter"
                  :items="$findPartnerBookingStatus()"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Guest Numbers"
                  v-model="booking_guest_number_filter"
                  :items="$findGuestNumbers()"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Guest Type(s)"
                  v-model="booking_guest_type_filter"
                  :items="allConservationFees"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="payment_person"
                  item-value="payment_person"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Booking Source"
                  v-model="booking_source_filter"
                  :items="$findPartnerBookingSource()"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Accommodation(s)"
                  v-model="booking_accommodation_filter"
                  :items="allFacilities"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="name"
                  item-value="public_id"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Activity(s)"
                  v-model="booking_activity_filter"
                  :items="activeInventory"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="name"
                  item-value="public_id"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <h4 class="earth-color">BOOKINGS ({{$filterPartnerBooking.length}})</h4>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="$filterPartnerBooking"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td data-label="Created At">{{ formated_date_time(props.item.created_at) }}</td>
          <td data-label="OBTS Booking Ref">
            <router-link :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id }}">
              <a class="futuristic-link">{{ props.item.booking_ref_code }}</a>
            </router-link>
          </td>
          <td data-label="In-House Ref">{{ props.item.partner_booking_ref }}</td>
          <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
          <td data-label="Entry Pax">{{ props.item.guest_total }}</td>
          <td data-label="Check In">{{ formated_date(props.item.booking_check_in_date) }}</td>
          <td data-label="Check Out">{{ formated_date(props.item.booking_check_out_date) }}</td>
          <td data-label="Booking Amount">{{ props.item.booking_currency }} {{ $roundOff(props.item.booking_total) }}</td>
          <td data-label="Booking Source">{{ props.item.session_user }}</td>
          <td data-label="Booking Status" :style="props.item.booking_color">{{ props.item.booking_status }}</td>
          <td data-label="Action">
            <v-btn
              :depressed="true"
              small
              color="primary"
              @click="openBooking(props.item.booking_public_id)"
              class="futuristic-btn"
            >View Booking</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              :items="rowsPerPageItems"
              v-model="pagination.rowsPerPage"
              label="Rows per page"
              class="futuristic-input"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 v-if="$filterPartnerBooking.length > 0">
            <v-btn
              :depressed="true"
              color="primary"
              @click="generateCustomCsv()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >Generate Report</v-btn>
            <v-btn
              v-if="route === 'PartnerBookings' && partnerBookings.length > 15"
              :depressed="true"
              color="info"
              @click="getMore()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET MORE</v-btn>
            <v-btn
              v-if="route === 'PartnerBookings' && partnerBookings.length > 15"
              :depressed="true"
              color="default"
              @click="getAllBookings()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET ALL</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="$filterPartnerBooking.length <= 0 && route === 'PartnerBookings'">
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import SearchTabs from '../Bookings/FindBooking'
export default {
  components: { SearchTabs },
  data () {
    return {
      search: '',
      lmenu: JSON.parse(localStorage.getItem('unem')),
      route: this.$route.name,
      page: 2,
      columns: [
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'OBTS Booking Ref',
          value: 'booking_ref_code'
        },
        {
          text: 'In-House Ref',
          value: 'partner_booking_ref'
        },
        {
          text: 'Client Name',
          value: 'booking_done_by'
        },
        {
          text: 'Entry Pax',
          value: 'guest_total'
        },
        {
          text: 'Check In',
          value: 'booking_check_in_date'
        },
        {
          text: 'Check Out',
          value: 'booking_check_out_date'
        },
        {
          text: 'Booking Amount',
          value: 'booking_total'
        },
        {
          text: 'Booking Source',
          value: 'session_user'
        },
        {
          text: 'Booking Status',
          value: 'booking_status'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }],
    }
  },
  created () {
    this.$store.dispatch('get_partner_bookings', this.lmenu.instiution_id)
  },
  beforeCreate () {
    this.$store.dispatch('get_active_activities')
    this.$store.dispatch('get_active_facilities')
    this.$store.dispatch('get_all_conservation_fees')
  },
  methods: {
    viewBooking: function (publicId) {
      this.$router.push({
        name: 'Booking',
        params: {
          booking_id: publicId
        }
      })
    },
    openBooking: function (publicId) {
      this.$router.push({
        name: 'Booking',
        params: {
          booking_id: publicId
        }
      })
    },
    getMore () {
      this.loading = true
      let data = {
        publicId: this.lmenu.instiution_id,
        page: this.page
      }
      if (this.page === 2) {
        this.$store.dispatch('get_partner_bookings_streamed', data)
        this.page = this.page + 1
      } else {
     
        this.$store.dispatch('get_partner_bookings_streamed', data)
        this.page = this.page + 1
      }
    },
    getAllBookings () {
      this.loading = true
      let data = {
        publicId: this.lmenu.instiution_id,
        page: 0
      }
      this.$store.dispatch('get_partner_bookings_streamed_all', data)
    },
    generateCustomCsv () {
      var idList = []
      this.$filterPartnerBooking.map(function (booking) {
        idList.push(booking.booking_public_id)
      })
      var data = {
        booking_ids: idList,
        partner_id: this.lmenu.instiution_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('generate_custom_partner_csv', data)
    }
  }
}
</script>

<style scoped>
.futuristic-expansion {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-expansion >>> .v-expansion-panel__header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}


.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  margin: 0 8px 8px;
}

.futuristic-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #4caf50;
  font-weight: 600;
  font-size: 13px;
}

.futuristic-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f5f7fa;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 8px;
}

.futuristic-link {
  color: #4caf50;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #388e3c;
}

@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }

  .futuristic-input {
    max-width: 100%;
    margin-top: 12px;
  }

  .futuristic-table {
    margin: 0 4px 4px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 12px;
    padding: 0 6px;
  }

  .futuristic-table >>> tbody tr td {
    font-size: 12px;
    padding: 0 6px;
  }
}

@media (max-width: 600px) {
  .futuristic-card, .futuristic-expansion {
    border-radius: 6px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table >>> thead {
    display: none;
  }

  .futuristic-table >>> tbody tr {
    display: block;
    margin-bottom: 12px;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .futuristic-table >>> tbody tr td {
    display: block;
    text-align: right;
    padding: 8px 12px;
    position: relative;
    border-bottom: 1px solid #e0e0e0;
  }

  .futuristic-table >>> tbody tr td:last-child {
    border-bottom: none;
  }

  .futuristic-table >>> tbody tr td::before {
    content: attr(data-label);
    position: absolute;
    left: 12px;
    font-weight: 600;
    color: #4caf50;
  }

  .futuristic-table >>> tbody tr td:nth-child(1)::before { content: 'Created At'; }
  .futuristic-table >>> tbody tr td:nth-child(2)::before { content: 'OBTS Booking Ref'; }
  .futuristic-table >>> tbody tr td:nth-child(3)::before { content: 'In-House Ref'; }
  .futuristic-table >>> tbody tr td:nth-child(4)::before { content: 'Client Name'; }
  .futuristic-table >>> tbody tr td:nth-child(5)::before { content: 'Entry Pax'; }
  .futuristic-table >>> tbody tr td:nth-child(6)::before { content: 'Check In'; }
  .futuristic-table >>> tbody tr td:nth-child(7)::before { content: 'Check Out'; }
  .futuristic-table >>> tbody tr td:nth-child(8)::before { content: 'Booking Amount'; }
  .futuristic-table >>> tbody tr td:nth-child(9)::before { content: 'Booking Source'; }
  .futuristic-table >>> tbody tr td:nth-child(10)::before { content: 'Booking Status'; }
  .futuristic-table >>> tbody tr td:nth-child(11)::before { content: 'Action'; }
}
</style>
